/* Happy Yak storefront mockup: mobile nav, product gallery, colorway picker. */
(function () {
  // ---------- mobile nav ----------
  var nav = document.querySelector('[data-mobile-nav]');
  var openBtn = document.querySelector('[data-mobile-nav-open]');
  function setNav(open) {
    if (!nav) return;
    nav.setAttribute('data-open', open ? 'true' : 'false');
    nav.setAttribute('aria-hidden', open ? 'false' : 'true');
    if (openBtn) openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.body.style.overflow = open ? 'hidden' : '';
    // 0019: lock the page itself too; with only <body> locked, phones still scrolled the page behind the open menu.
    document.documentElement.style.overflow = open ? 'hidden' : '';
  }
  if (openBtn) openBtn.addEventListener('click', function () { setNav(true); });
  document.querySelectorAll('[data-mobile-nav-close]').forEach(function (el) { el.addEventListener('click', function () { setNav(false); }); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setNav(false); });

  // ---------- gallery ----------
  var main = document.getElementById('ms-main-photo');
  document.querySelectorAll('.thumbs button').forEach(function (b) {
    b.addEventListener('click', function () {
      document.querySelectorAll('.thumbs button').forEach(function (x) { x.setAttribute('aria-selected', 'false'); });
      b.setAttribute('aria-selected', 'true');
      if (main) { main.src = b.dataset.img; main.srcset = ''; }
    });
  });

  // ---------- colorway picker ----------
  var picker = document.querySelector('[data-colorway-picker]');
  if (!picker) return;
  var product = null;
  try { product = JSON.parse(document.getElementById('ms-product-json').textContent); } catch (e) { return; }
  var sizeNames = { S: ['S', 'Small'], M: ['M', 'Medium'], L: ['L', 'Large'], XL: ['XL', 'Extra Large', 'X-Large'] };
  var notes = { S: "Small fits men's 4–5.5 / women's 5–6.5.", M: "Medium fits men's 6–8.5 / women's 7–9.5.", L: "Large fits men's 9–12 / women's 10–13.", XL: "Extra Large fits men's 12.5–14.5." };
  var cws = picker.querySelectorAll('.cw'), sizes = picker.querySelectorAll('.size');
  var cwName = document.getElementById('cw-name'), note = document.getElementById('size-note');
  var add = document.getElementById('ms-add'), idInput = document.getElementById('ms-variant-id'), avail = document.getElementById('ms-avail');

  function sizeMatches(value, size) {
    var v = String(value).trim().toLowerCase();
    return sizeNames[size].some(function (n) { return n.toLowerCase() === v; });
  }
  // Find the real variant for a colorway + size.
  // New 3-pack (Colorway x Size options): a variant whose options include the colorway name and the size.
  // Old 3-pack (one size option per colour): "Classic Trio" maps to the variant where every option equals the size.
  function findVariant(cw, size) {
    var variants = product.variants || [];
    for (var i = 0; i < variants.length; i++) {
      var opts = (variants[i].options || []).map(String);
      var hasCw = opts.some(function (o) { return o.toLowerCase() === cw.toLowerCase(); });
      var hasSize = opts.some(function (o) { return sizeMatches(o, size); });
      if (hasCw && hasSize) return variants[i];
    }
    if (cw === 'Classic Trio') {
      for (var j = 0; j < variants.length; j++) {
        var o2 = variants[j].options || [];
        if (o2.length && o2.every(function (o) { return sizeMatches(o, size); })) return variants[j];
      }
    }
    return null;
  }
  function current() {
    var c = picker.querySelector('.cw[aria-checked=true]'), s = picker.querySelector('.size[aria-checked=true]');
    return { cw: c ? c.dataset.cw : '', size: s ? s.dataset.size : '' };
  }
  function refreshCart() {
    var c = current(), v = findVariant(c.cw, c.size);
    if (v && v.available) {
      idInput.value = v.id; add.disabled = false; add.textContent = 'Add to cart · ' + add.dataset.price; avail.hidden = true;
    } else if (v) {
      idInput.value = v.id; add.disabled = true; add.textContent = 'Sold out'; avail.hidden = true;
    } else {
      idInput.value = ''; add.disabled = true; add.textContent = 'Add to cart · ' + add.dataset.price;
      avail.hidden = false; avail.textContent = c.cw + ' in ' + c.size + ' isn’t available in this pack.';
    }
  }
  function applyCw(btn) {
    cws.forEach(function (x) { x.setAttribute('aria-checked', 'false'); });
    btn.setAttribute('aria-checked', 'true');
    cwName.textContent = btn.dataset.cw;
    var allowed = btn.dataset.sizes.split(',');
    var lost = false;
    sizes.forEach(function (s) {
      var ok = allowed.indexOf(s.dataset.size) > -1;
      s.disabled = !ok;
      if (!ok && s.getAttribute('aria-checked') === 'true') { s.setAttribute('aria-checked', 'false'); lost = true; }
    });
    if (lost || !picker.querySelector('.size[aria-checked=true]')) {
      var first = picker.querySelector('.size:not([disabled])');
      first.setAttribute('aria-checked', 'true');
      note.textContent = btn.dataset.cw + ' comes in ' + allowed.join(', ') + ' only. Switched to ' + first.dataset.size + '.';
    } else {
      note.textContent = notes[current().size] || '';
    }
    refreshCart();
  }
  cws.forEach(function (b) { b.addEventListener('click', function () { applyCw(b); }); });
  sizes.forEach(function (s) {
    s.addEventListener('click', function () {
      if (s.disabled) return;
      sizes.forEach(function (x) { x.setAttribute('aria-checked', 'false'); });
      s.setAttribute('aria-checked', 'true');
      note.textContent = notes[s.dataset.size] || '';
      refreshCart();
    });
  });
  applyCw(picker.querySelector('.cw[aria-checked=true]') || cws[0]);
})();
